module.exports = __webpack_public_path__ + "img/SDG-11-EN-INVERTED.4b461377.png";